<template>
  <ModalDialog
    ref="dialog"
    title="Edit Customer Pricing"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-pencil"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="contactForm" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>Editing customer default sales rate will affect any active customer price list for this customer</NotificationBarTitle>
        <ul>
          <li>Unless explicitly set in customer price lists, category sales rates will default to the customer sales rate</li>
          <li>Update customer price list category sales rates directly for more control</li>
        </ul>
      </NotificationBar>

      <FormRow label="Default Sales Rate">
        <SalesRateSelect v-model="contact.defaultSalesRateId" field="defaultSalesRateId" note="Sales rate used if the customer has no active price list" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import SalesRateSelect from '@/modules/pricing/components/salesRateSelect'

export default {
  name: "ContactEditPricingDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    SalesRateSelect
  },
  props: {
    contactId: Number
  },
  data() {
    return {
      contact: {
        isCustomer: false,
        isSupplier: false
      },
      contactForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show(contact) {
      // Reset form
      this.contact = {
      }
      this.contactForm = {}
      this.submitting = false

      if(contact != null) {
        this.contact = _.cloneDeep(contact)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var contactData = _.cloneDeep(this.$data.contact)
      var updateData = _.pick(contactData, [
        'defaultSalesRateId'
      ])

      this.$apiService.contactService.updateContact(this.contactId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.contactForm = this.processFormResponse(err)
        })
    }
  }
}
</script>